
const systemKey = {
	O365: "o365",
	GOOGLE: "google",
	EXCHANGE2010: "exchange2010",
	EXCHANGE2013: "exchange2013"
}

const dateTimeFormat = {
	displayFullDateTime: "DD MMMM YYYY HH:mm",
	displayDate: "DD MMMM YYYY",
	displayTime: "HH:mm",

	apiFullDateTime: "YYYY-MM-DDTHH:mm:ss",
	apiDate: "YYYY-MM-DD"
}

const defaultValueCode = {
    PLEASE_SELECT: "PLEASE_SELECT",
    NO_SELECT: "NO_SELECT",
    SELECT_ALL: "SELECT_ALL"
}

const downloadFileType = {
	EXCEL: {
		type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		filenameExtension: "xlsx"
	}
}


export {
	systemKey,
	dateTimeFormat,
	defaultValueCode,
	downloadFileType,
}


// WEBPACK FOOTER //
// ./src/constant.js